import React from 'react'

function Download() {
  return (
    <section className='download-section'>
        <div className="container">
                <div className="app-download">
                    <h2>Download our app to get most out of it</h2>
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptatum consectetur itaque  
                        tempore sint est, suscipit maiores expedita minima.</p>
                    <div className="app-store">
                        <img src="../assets/images/download/play-store.svg" alt="" />
                        <img src="../assets/images/download/app.store.svg" alt="" />
                    </div>
                </div>
               
        </div>
    </section>
  )
}

export default Download